// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__EOD9o","tag__prefix":"tag_tag__prefix__kvE9J","tag__close":"tag_tag__close__6fLNS"};